export interface Category {
  name: string;
  displayName: string;
  isCustom: boolean;
}

export interface CustomCategory {
  name: string;
  displayName: string;
}

// Standard-Kategorien mit deutschen Übersetzungen
export const DEFAULT_CATEGORY_TRANSLATIONS: Record<string, string> = {
  // Einkommen
  'INCOME': 'Einkommen',
  'SALARY': 'Gehalt',
  
  // Ausgaben - Allgemein
  'EXPENSE': 'Allgemeine Ausgabe',
  'OTHER': 'Sonstiges',
  
  // Lebenshaltung
  'FOOD': 'Lebensmittel',
  'HOUSING': 'Wohnen & Miete',
  'UTILITIES': 'Nebenkosten',
  'TRANSPORT': 'Transport & Verkehr',
  'ENTERTAINMENT': 'Unterhaltung',
  'HEALTHCARE': 'Gesundheit',
  
  // Finanzen
  'DEBT_PAYMENT': 'Schuldentilgung',
  'SAVINGS': 'Sparen',
  'INVESTMENT': 'Investitionen',
  'TRANSFER': 'Überweisung'
};

// Account-Types mit deutschen Übersetzungen
export const ACCOUNT_TYPE_TRANSLATIONS: Record<string, string> = {
  'CHECKING': 'Girokonto',
  'SAVINGS': 'Sparkonto',
  'CASH': 'Bargeld',
  'CREDIT_CARD': 'Kreditkarte',
  'INVESTMENT': 'Anlagekonto',
  'OTHER': 'Sonstiges'
};

// Hilfsfunktion um Display-Name zu ermitteln
export function getCategoryDisplayName(category: string, customCategories: CustomCategory[] = []): string {
  // Prüfe zuerst benutzerdefinierte Kategorien
  const customCategory = customCategories.find(c => c.name === category);
  if (customCategory) {
    return customCategory.displayName;
  }
  
  // Fallback auf Standard-Übersetzungen
  return DEFAULT_CATEGORY_TRANSLATIONS[category] || category;
}

// Hilfsfunktion um alle verfügbaren Kategorien zu sammeln
export function getAllAvailableCategories(customCategories: CustomCategory[] = []): Category[] {
  const defaultCategories = Object.keys(DEFAULT_CATEGORY_TRANSLATIONS).map(key => ({
    name: key,
    displayName: DEFAULT_CATEGORY_TRANSLATIONS[key],
    isCustom: false
  }));
  
  const userCategories = customCategories.map(cat => ({
    name: cat.name,
    displayName: cat.displayName,
    isCustom: true
  }));
  
  return [...defaultCategories, ...userCategories];
}

// Hilfsfunktion für Account-Type Display-Namen
export function getAccountTypeDisplayName(accountType: string): string {
  return ACCOUNT_TYPE_TRANSLATIONS[accountType] || accountType;
}